module.exports = __webpack_public_path__ + "static/income.04118cb8.png";